export default function setToastSlice(state, action) {
	const newToast = state.toast.slice();
	newToast.splice(action.payload.index, 1);
	return { ...state, toast: newToast };
}